import React from 'react';
import { FEATURE_TOGGLE } from 'modules/common/constants';

interface FeatureProps {
  name: string;
  children?: React.ReactNode | React.ReactNode[] | null;
  fallback?: React.ReactNode | React.ReactNode[] | null;
}

export const Feature = ({
  name,
  children = null,
  fallback = null,
}: FeatureProps): JSX.Element | null => {
  if (FEATURE_TOGGLE[name]) {
    if (FEATURE_TOGGLE[name].active) return children as JSX.Element;
    if (fallback) return fallback as JSX.Element;
  }
  return null;
};

export default Feature;
